













































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import CreateWalletRequest from '@/models/Accounts/DepositAccounts/Wallets/CreateWalletRequest';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'WalletsCreateDialog', components: { FieldLabel } })
export default class extends SaascadaVueDialog {

    dialog = false;
    valid = false;
    createUxWalletRequest: CreateWalletRequest = new CreateWalletRequest();

    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.createUxWalletRequest = new CreateWalletRequest();
        }
    }

    get secondaryWalletTypeOptions() {
        return DepositAccountSettingsModule.productIssue.secondaryWalletSettings?.secondaryWalletTypes;
    }

    get currencyOptions() {
        if (this.createUxWalletRequest.secondaryWalletTypeCode) {
            const selectedSecondaryWallet = DepositAccountSettingsModule.productIssue.secondaryWalletSettings?.secondaryWalletTypes.find(wallet => wallet.generalSettings.code === this.createUxWalletRequest.secondaryWalletTypeCode);
            return selectedSecondaryWallet.generalSettings.allowedCurrencies;
        }
        return null;
    }

    async save() {
        if (!this.valid) {
            return;
        }
        else {
            this.dialog = false;
            await DepositAccountModule.createDepositAccountWallet(this.createUxWalletRequest);
        }
    }

}
